/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M15 22V14M15 14V2L16.5761 2.39403C17.4428 2.61069 17.8761 2.71903 18.1988 2.96062C18.4834 3.17378 18.7061 3.459 18.8439 3.78687C19 4.15848 19 4.60515 19 5.49848V10.0223C19 10.7402 19 11.0992 18.8907 11.4161C18.794 11.6963 18.6363 11.9516 18.4288 12.1634C18.1943 12.4029 17.8732 12.5634 17.2311 12.8845L15 14Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M7 2V11M7 22V11M7 11L5.42496 9.94997C4.90398 9.60265 4.64349 9.42899 4.45491 9.19955C4.28796 8.99643 4.1627 8.76238 4.0863 8.5108C4 8.22663 4 7.91355 4 7.28741V2M7 11L8.57504 9.94997C9.09602 9.60265 9.35651 9.42899 9.54509 9.19955C9.71204 8.99643 9.8373 8.76238 9.9137 8.5108C10 8.22663 10 7.91355 10 7.28741V2"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M16.5761 2.39403L15 2V14L17.2311 12.8845L17.2311 12.8844C17.8732 12.5634 18.1943 12.4029 18.4288 12.1634C18.6363 11.9516 18.794 11.6963 18.8907 11.4161C19 11.0992 19 10.7402 19 10.0223V5.49848C19 4.60515 19 4.15848 18.8439 3.78687C18.7061 3.459 18.4834 3.17378 18.1988 2.96062C17.8761 2.71903 17.4428 2.61069 16.5761 2.39403Z"
				fill="currentColor"
			/>
			<path
				d="M15 22V14M15 14V2L16.5761 2.39403C17.4428 2.61069 17.8761 2.71903 18.1988 2.96062C18.4834 3.17378 18.7061 3.459 18.8439 3.78687C19 4.15848 19 4.60515 19 5.49848V10.0223C19 10.7402 19 11.0992 18.8907 11.4161C18.794 11.6963 18.6363 11.9516 18.4288 12.1634C18.1943 12.4029 17.8732 12.5634 17.2311 12.8845L15 14ZM7 2V11M7 11V22M7 11L5.42496 9.94997C4.90398 9.60265 4.64349 9.42899 4.45491 9.19955C4.28796 8.99643 4.1627 8.76238 4.0863 8.5108C4 8.22663 4 7.91355 4 7.28741V2M7 11L8.57504 9.94997C9.09602 9.60265 9.35651 9.42899 9.54509 9.19955C9.71204 8.99643 9.8373 8.76238 9.9137 8.5108C10 8.22663 10 7.91355 10 7.28741V2"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.182 1.2724C14.9579 1.21639 14.7206 1.26672 14.5385 1.40885C14.3565 1.55098 14.2501 1.76906 14.2501 2.00001V14V22C14.2501 22.4142 14.5859 22.75 15.0001 22.75C15.4143 22.75 15.7501 22.4142 15.7501 22V14.4635L17.5666 13.5553L17.6636 13.5069C18.2106 13.2339 18.6402 13.0196 18.9647 12.6882C19.25 12.397 19.4669 12.046 19.5998 11.6606C19.751 11.2221 19.7507 10.742 19.7501 10.1307L19.7501 10.0223V5.49849L19.7502 5.36131C19.7509 4.60383 19.7515 4.01073 19.5354 3.49637C19.346 3.04554 19.0398 2.65337 18.6484 2.36028C18.2018 2.02588 17.6263 1.8826 16.8912 1.69961L16.7581 1.66643L15.182 1.2724ZM4.75009 2.00001C4.75009 1.58579 4.4143 1.25001 4.00009 1.25001C3.58588 1.25001 3.25009 1.58579 3.25009 2.00001V7.28742L3.25004 7.38119C3.24965 7.91549 3.24935 8.33556 3.36875 8.72875C3.47381 9.07467 3.64604 9.39648 3.87559 9.67578C4.1365 9.99323 4.48619 10.226 4.93097 10.522L5.00902 10.574L6.25009 11.4014V22C6.25009 22.4142 6.58588 22.75 7.00009 22.75C7.4143 22.75 7.75009 22.4142 7.75009 22V11.4014L8.99116 10.574L9.06921 10.522C9.51399 10.226 9.86368 9.99323 10.1246 9.67578C10.3541 9.39648 10.5264 9.07467 10.6314 8.72875C10.7508 8.33556 10.7505 7.91549 10.7501 7.3812V7.38119L10.7501 7.28742V2.00001C10.7501 1.58579 10.4143 1.25001 10.0001 1.25001C9.58588 1.25001 9.25009 1.58579 9.25009 2.00001V7.28742C9.25009 7.96026 9.24245 8.14042 9.19615 8.29287C9.1484 8.45011 9.07011 8.59639 8.96577 8.72334C8.8646 8.84643 8.71894 8.95272 8.1591 9.32594L7.75009 9.59862V2.00001C7.75009 1.58579 7.4143 1.25001 7.00009 1.25001C6.58588 1.25001 6.25009 1.58579 6.25009 2.00001V9.59862L5.84107 9.32594C5.28124 8.95272 5.13557 8.84643 5.03441 8.72334C4.93006 8.59639 4.85178 8.45011 4.80403 8.29287C4.75773 8.14042 4.75009 7.96026 4.75009 7.28742V2.00001Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M15 2L16.5761 2.39403C17.4428 2.61069 17.8761 2.71903 18.1988 2.96062C18.4834 3.17378 18.7061 3.459 18.8439 3.78687C19 4.15848 19 4.60515 19 5.49848V10.0223C19 10.7402 19 11.0992 18.8907 11.4161C18.794 11.6963 18.6363 11.9516 18.4288 12.1634C18.1943 12.4029 17.8732 12.5634 17.2311 12.8845L15 14M15 22V14M15 14V6M7 2V11M7 11V22M7 11L8.57504 9.94997C9.09602 9.60265 9.35651 9.42899 9.54509 9.19955C9.71204 8.99643 9.8373 8.76238 9.9137 8.5108C10 8.22663 10 7.91355 10 7.28741V2M4 9V2"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M15 22V14M15 14V2L16.5761 2.39403C17.4428 2.61069 17.8761 2.71903 18.1988 2.96062C18.4834 3.17378 18.7061 3.459 18.8439 3.78687C19 4.15848 19 4.60515 19 5.49848V10.0223C19 10.7402 19 11.0992 18.8907 11.4161C18.794 11.6963 18.6363 11.9516 18.4288 12.1634C18.1943 12.4029 17.8732 12.5634 17.2311 12.8845L15 14ZM7 2V11M7 11V22M7 11L5.42496 9.94997C4.90398 9.60265 4.64349 9.42899 4.45491 9.19955C4.28796 8.99643 4.1627 8.76238 4.0863 8.5108C4 8.22663 4 7.91355 4 7.28741V2M7 11L8.57504 9.94997C9.09602 9.60265 9.35651 9.42899 9.54509 9.19955C9.71204 8.99643 9.8373 8.76238 9.9137 8.5108C10 8.22663 10 7.91355 10 7.28741V2"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.00009 1.25C4.4143 1.25 4.75009 1.58579 4.75009 2V7.28741C4.75009 7.96025 4.75773 8.14041 4.80403 8.29286C4.85178 8.4501 4.93007 8.59638 5.03441 8.72333C5.13557 8.84642 5.28124 8.95271 5.84107 9.32594L6.25009 9.59861V2C6.25009 1.58579 6.58588 1.25 7.00009 1.25C7.4143 1.25 7.75009 1.58579 7.75009 2V9.59861L8.1591 9.32594C8.71894 8.95271 8.8646 8.84642 8.96577 8.72333C9.07011 8.59638 9.1484 8.4501 9.19615 8.29286C9.24245 8.14041 9.25009 7.96025 9.25009 7.28741V2C9.25009 1.58579 9.58588 1.25 10.0001 1.25C10.4143 1.25 10.7501 1.58579 10.7501 2V7.28741C10.7501 7.31906 10.7501 7.35031 10.7501 7.38118C10.7505 7.91549 10.7508 8.33556 10.6314 8.72874C10.5264 9.07466 10.3541 9.39648 10.1246 9.67577C9.86368 9.99322 9.51399 10.226 9.06921 10.522C9.04351 10.5391 9.01749 10.5565 8.99116 10.574L7.75009 11.4014V22C7.75009 22.4142 7.4143 22.75 7.00009 22.75C6.58588 22.75 6.25009 22.4142 6.25009 22V11.4014L5.00902 10.574C4.98269 10.5565 4.95667 10.5391 4.93097 10.522C4.48619 10.226 4.1365 9.99322 3.87559 9.67577C3.64604 9.39648 3.47381 9.07466 3.36875 8.72874C3.24935 8.33556 3.24965 7.91548 3.25004 7.38118C3.25007 7.35031 3.25009 7.31906 3.25009 7.28741V2C3.25009 1.58579 3.58588 1.25 4.00009 1.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.1819 1.2724C14.9578 1.21639 14.7205 1.26672 14.5384 1.40885C14.3564 1.55098 14.25 1.76906 14.25 2.00001V14V22C14.25 22.4142 14.5858 22.75 15 22.75C15.4142 22.75 15.75 22.4142 15.75 22V14.4635L17.5665 13.5553L17.6635 13.5069C18.2105 13.2339 18.6401 13.0196 18.9647 12.6882C19.2499 12.397 19.4668 12.046 19.5997 11.6606C19.751 11.2221 19.7506 10.742 19.7501 10.1307L19.75 10.0223V5.49849L19.7501 5.36131V5.36131C19.7508 4.60383 19.7514 4.01073 19.5353 3.49637C19.3459 3.04554 19.0397 2.65337 18.6483 2.36028C18.2017 2.02588 17.6262 1.8826 16.8911 1.69961L16.758 1.66643L15.1819 1.2724Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
